import { useEffect } from 'react'
import { useHistory } from 'react-router'

import commonRepo from '@/repository/common.repo'
import { fullModalRoutes, RouteName } from '@/router'
import modalService from '@/service/modal.service'

export const useSavePath = () => {
  const history = useHistory<{ ignorePathSave?: boolean }>()
  useEffect(() => {
    const unblock = history.block(({ pathname: to, state }, action) => {
      const from = history.location.pathname
      const [, fromHeader, fromSubHeader] = from.split('/')
      const [, toHeader, toSubHeader] = to.split('/')

      if (
        [RouteName.lesson, ...fullModalRoutes].includes(`/${fromHeader}`) ||
        state?.ignorePathSave
      ) {
        return
      }

      if (fromHeader !== toHeader) {
        commonRepo.router.lastLocationMap.set(`/${fromHeader}`, from)
      } else if (fromSubHeader !== toSubHeader) {
        commonRepo.router.lastLocationMap.set(`/${fromHeader}/${fromSubHeader}`, from)
      }

      if (action === 'POP') {
        if (modalService.modalList.length > 0) {
          modalService.closeModal()
          return false
        }
      }
    })
    return () => unblock()
  }, [history.location.pathname])
}
